import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowLeft, ArrowRight, Quote, Star } from "lucide-react";
import { testimonials } from "../../mock/mock";

export default function Testimonials() {
  const [i, setI] = useState(0);
  const total = testimonials.length;
  const t = testimonials[i];
  const go = (dir) => setI((p) => (p + dir + total) % total);

  useEffect(() => {
    const timer = setInterval(() => {
      setI((p) => (p + 1) % total);
    }, 4000);
    return () => clearInterval(timer);
  }, [total]);

  return (
    <section className="relative py-24 md:py-32 border-t border-white/5 overflow-hidden">
      <div className="halo left-1/2 -translate-x-1/2 top-10 opacity-50" />
      <div className="relative mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="flex items-end justify-between mb-10">
          <div>
            <div className="section-label mb-6">Client Reviews</div>
            <h2 className="font-display text-[42px] md:text-[64px] leading-[1.02] tracking-[-0.02em] max-w-3xl">
              Trusted by <span className="italic sage-text">clients</span>.
            </h2>
          </div>
          <div className="hidden md:flex items-center gap-2">
            <button onClick={() => go(-1)} aria-label="Previous"
              className="h-12 w-12 rounded-full border border-white/10 inline-flex items-center justify-center text-[var(--text-dim)] hover:text-[var(--sage)] hover:border-[var(--sage)]/50 transition-colors">
              <ArrowLeft size={16} />
            </button>
            <button onClick={() => go(1)} aria-label="Next"
              className="h-12 w-12 rounded-full border border-white/10 inline-flex items-center justify-center text-[var(--text-dim)] hover:text-[var(--sage)] hover:border-[var(--sage)]/50 transition-colors">
              <ArrowRight size={16} />
            </button>
          </div>
        </div>

        <div className="relative rounded-3xl glass-strong p-8 md:p-14 min-h-[320px]">
          <Quote size={54} className="absolute -top-6 left-8 text-[var(--sage)] opacity-90" strokeWidth={1} />

          <AnimatePresence mode="wait">
            <motion.div key={t.name}
              initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.45 }}>
              <div className="flex items-center gap-1 mb-6">
                {Array.from({ length: 5 }).map((_, idx) => (
                  <Star key={idx} size={16} className="text-[var(--sage)] fill-[var(--sage)]" />
                ))}
              </div>
              <p className="font-display text-[24px] md:text-[34px] leading-[1.3] tracking-[-0.01em] text-[var(--text)] max-w-4xl">
                "{t.quote}"
              </p>
              <div className="mt-8 flex items-center gap-4">
                <div className="h-12 w-12 rounded-full bg-[var(--sage)]/15 border border-[var(--sage)]/30 inline-flex items-center justify-center font-display text-lg">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="font-medium">{t.name}</div>
                  <div className="mono text-[11px] tracking-[0.14em] uppercase text-[var(--text-dim)]">{t.role}</div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          <div className="mt-10 flex items-center justify-start">
            <div className="flex items-center gap-2">
              {testimonials.map((_, idx) => (
                <button key={idx} onClick={() => setI(idx)} aria-label={`Testimonial ${idx + 1}`}
                  className={`h-[3px] rounded-full transition-all ${idx === i ? "w-10 bg-[var(--sage)]" : "w-5 bg-white/15"}`} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
